import styled from "styled-components";

export const Left = styled.div`
  width: 30%;
`;
export const Center = styled.div`
  width: 50%;
`;

export const Container = styled.div`
  width: 1000px;
  display: flex;
`;
